import * as React from 'react';
export const arrowUpDownSvg = React.forwardRef(function arrowUpDownSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.03 4.664a.75.75 0 0 1 .938 1.172l-2.5 2a.75.75 0 0 1-.937 0l-2.5-2a.751.751 0 0 1 .937-1.172L4 6.29l2.03-1.625ZM3.638.093a.75.75 0 0 1 .83.071l2.5 2a.75.75 0 0 1-.937 1.172L4 1.71 1.968 3.336a.75.75 0 0 1-.937-1.172l2.5-2 .107-.071Z',
    }),
  );
});
arrowUpDownSvg.defaultProps = {
  width: '8',
  height: '8',
  viewBox: '0 0 8 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowUpDown = {
  category: 'icon',
  colorable: true,
  name: 'arrowUpDown',
  svg: arrowUpDownSvg,
};
